import { template as template_fd579956df254118bf6adf64d27d0bb2 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../routes/render';
const Render = template_fd579956df254118bf6adf64d27d0bb2(`
  <div
    data-prerender
    data-prerender-id={{@model.cardId}}
    data-prerender-nonce={{@model.nonce}}
    data-prerender-status={{@model.status}}
  >
    {{outlet}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    model: Model;
}>;
export default RouteTemplate(Render);
